import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationLogin } from '../interfaces/application-login.interface';
import { EntityFilter } from '../interfaces/entity-filter.interface';
import { FilterOptions } from '../interfaces/filter-options.interface';

@Injectable({
  providedIn: 'root'
})
export class IntegrationTesterService {
	private readonly url: string = 'integrationTester';

	constructor(private http: HttpClient) {}

  public getFields(integrationId: number): Observable<string[]> {
		return this.http.get<string[]>(this.url + '/' + integrationId);
	}

	public getAdminLogins(applicationId: number): Observable<any[]> {
		return this.http.get<any[]>(this.url + '/' + "getAdminLogins" + '/' + applicationId)
	}

	public canLogin(applicationLogin: ApplicationLogin): Observable<boolean> {
		return this.http.post<boolean>(this.url + '/' + "canLogin", applicationLogin)
	}

	public retrieveData(applicationLogin: ApplicationLogin, entityData: any, entityFilters: EntityFilter[], entityCount: number, isEncrypted: boolean, isRawLogin: boolean)
	{
		return this.http.post<any[]>(this.url + '/' + "getResult", { applicationLogin: applicationLogin, entityData: entityData, genericFilters: entityFilters, EntityLimit: entityCount, isEncrypted: isEncrypted, isRawLogin: isRawLogin})
	}

	public getFieldProperties(assemblyname: string): Observable<string[]> {
		return this.http.get<string[]>(this.url + '/' + "objectProperties" + '/' + assemblyname)
	}
	
	public getFilterOptions(integrationId: number): Observable<FilterOptions[]> {
		return this.http.get<FilterOptions[]>(this.url + '/' + 'filterOptions' + '/' + integrationId)
	}

	public retrieveRawData(applicationLogin: ApplicationLogin, rawQuery: string, entityCount: number): Observable<any[]> 
	{
		return this.http.post<any[]>(this.url + '/' + 'rawQuery', {applicationLogin: applicationLogin, rawQuery: rawQuery, EntityLimit: entityCount })
	}

	public getPickList(applicationLogin: ApplicationLogin, entityName: string) {
		return this.http.post<any[]>(this.url + '/' + 'getPickList', {applicationLogin: applicationLogin, entityName: entityName})
	}
}
